import * as React from 'react';

import { Modal } from '@lightspeed/flame/Modal';

import ModalBody from './ModalBody';
import ModalFooter from './ModalFooter';
import ModalHeader from './ModalHeader';

interface Props {
  isOpen: boolean;
  onCloseModal?: () => void;
  onSaveModal?: () => void;
  setIsOpen: (newIsOpen: boolean) => void;
  readOnly?: boolean;
}

const EditShopsModal: React.FC<Props> = ({
  isOpen,
  onCloseModal,
  onSaveModal,
  setIsOpen,
  readOnly = false,
}) => {
  const handleOnCloseModal = () => {
    onCloseModal?.();
    setIsOpen(false);
  };

  const handleOnSaveModal = () => onSaveModal?.();

  return (
    <Modal
      css={{ width: '600px', maxHeight: '900px' }}
      isOpen={isOpen}
      data-test="edit-shops-modal"
      onRequestClose={handleOnCloseModal}
    >
      <ModalHeader readOnly={readOnly} />
      <ModalBody readOnly={readOnly} />
      <ModalFooter
        onClickCancel={handleOnCloseModal}
        onClickSave={handleOnSaveModal}
        readOnly={readOnly}
      />
    </Modal>
  );
};

export default EditShopsModal;
